// components/screens/Screen1.tsx
import React from 'react';

export default function Screen1() {
  return (
    <div>
      <h1>Hello World 2</h1>
    </div>
  );
}
